import QualityBadge from "./QualityBadge";
import DuplicatePropertiesCard from "./DuplicatePropertiesCard";
import MissingCoordinatesCard from "./MissingCoordinatesCard";
import StalePropertiesCard from "./StalePropertiesCard";

const RealEstateSourceQualityDrawer = ({ detail, isLoading, errorMessage, onClose }) => {
  if (!detail && !isLoading && !errorMessage) {
    return null;
  }

  const quality = detail?.quality || {};

  return (
    <section className="panel-card admin-re-quality-drawer">
      <div className="admin-re-quality-drawer-header">
        <div>
          <p className="eyebrow">Source detail</p>
          <h2>{detail?.source?.sourceName || "Source quality"}</h2>
          {detail?.source?.sourceCode ? (
            <p className="muted">{detail.source.sourceCode}</p>
          ) : null}
        </div>
        <button type="button" className="midpoint-share-button" onClick={onClose}>
          Close
        </button>
      </div>

      {isLoading ? <p className="muted">Loading source quality…</p> : null}
      {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}

      {!isLoading && !errorMessage && detail ? (
        <>
          <div className="admin-re-quality-drawer-meta">
            <QualityBadge health={detail.source?.health} />
            <span className="muted">{detail.source?.sourceType}</span>
            {detail.source?.sourceUrl ? (
              <a href={detail.source.sourceUrl} target="_blank" rel="noreferrer">
                {detail.source.sourceUrl}
              </a>
            ) : null}
          </div>

          {detail.lifecycle ? (
            <div className="admin-re-lifecycle">
              <p className="eyebrow">Listing lifecycle</p>
              <p className="muted">
                Thresholds: stale after {detail.lifecycle.config?.staleAfterMisses} misses ·
                inactive after {detail.lifecycle.config?.inactiveAfterMisses} · retire after{" "}
                {detail.lifecycle.config?.retireAfterMisses}
              </p>
              <p>
                Active {detail.lifecycle.activeSourceListings} · stale candidates{" "}
                {detail.lifecycle.staleCandidates} · inactive {detail.lifecycle.inactiveListings}{" "}
                · retired {detail.lifecycle.retiredListings} · open reviews{" "}
                {detail.lifecycle.openReviewItems}
              </p>
              {detail.lifecycle.missingDetectionWarning ? (
                <p className="admin-data-health-error">{detail.lifecycle.missingDetectionWarning}</p>
              ) : null}
            </div>
          ) : null}

          {detail.latestRun ? (
            <div className="admin-re-latest-run">
              <p className="eyebrow">Latest run</p>
              <p>
                {detail.latestRun.runStatus} · received {detail.latestRun.recordsReceived} ·
                inserted {detail.latestRun.recordsInserted} · updated{" "}
                {detail.latestRun.recordsUpdated} · failed {detail.latestRun.recordsFailed}
                {detail.latestRun.canEvaluateMissingListings === false
                  ? " · missing detection skipped"
                  : ""}
              </p>
              {detail.latestRun.errorMessage ? (
                <p className="admin-data-health-error">{detail.latestRun.errorMessage}</p>
              ) : null}
            </div>
          ) : null}

          {detail.sections?.length ? (
            <div className="admin-re-section-breakdown">
              <p className="eyebrow">Sales and rentals</p>
              <div className="admin-data-health-summary">
                {detail.sections.map((section) => (
                  <article
                    key={section.sourceSection}
                    className={`admin-data-health-summary-card${
                      detail.activeSection?.sourceSection === section.sourceSection
                        ? " admin-data-health-summary-card--active"
                        : ""
                    }`}
                  >
                    <span className="eyebrow">{section.displayName}</span>
                    <strong>{section.totalProperties}</strong>
                    <p className="muted">
                      {section.listingType} · mapped {section.mappedProperties} · missing coords{" "}
                      {section.missingCoordinates} · missing price {section.missingPrice}
                    </p>
                  </article>
                ))}
              </div>
            </div>
          ) : null}

          <div className="admin-data-health-summary admin-re-quality-metrics">
            {[
              ["Total", quality.totalProperties],
              ["Mapped", quality.mappedProperties],
              ["Unmapped", quality.unmappedProperties],
              ["Missing coords", quality.missingCoordinates],
              ["Missing price", quality.missingPrice],
              ["Missing beds", quality.missingBedrooms],
              ["Missing baths", quality.missingBathrooms],
              ["Missing area", quality.missingBuildingArea],
              ["Stale", quality.staleProperties],
              ["Duplicates", quality.possibleDuplicateCount],
            ].map(([label, value]) => (
              <article key={label} className="admin-data-health-summary-card">
                <span className="eyebrow">{label}</span>
                <strong>{value ?? 0}</strong>
              </article>
            ))}
          </div>

          <div className="admin-re-quality-grid">
            <MissingCoordinatesCard properties={detail.samples?.missingCoordinates} />
            <StalePropertiesCard properties={detail.samples?.staleProperties} />
            <DuplicatePropertiesCard groups={detail.samples?.possibleDuplicates} />
          </div>
        </>
      ) : null}
    </section>
  );
};

export default RealEstateSourceQualityDrawer;
